
<div class="EntityDetailsStats">
    <OverviewMetricCard
        title="Umsatz diesen Monat"
        :value="displayRevenue"
        icon="ri-money-euro-circle-line"
        theme="green"
        size="small"
        :loading="isLoading"
    />

    <OverviewMetricCard
        title="Tage gearbeitet"
        :value="displayDaysWorked"
        icon="ri-calendar-check-line"
        theme="blue"
        size="small"
        :loading="isLoading"
    />

    <OverviewMetricCard
        title="€/km"
        :value="displayEuroPerKm"
        icon="ri-road-map-line"
        theme="orange"
        size="small"
        :loading="isLoading"
    />

    <OverviewMetricCard
        title="Schichtzeit"
        :value="displayShiftTime"
        icon="ri-timer-line"
        theme="cyan"
        size="small"
        :loading="isLoading"
    />

    <OverviewMetricCard
        title="Arbeitszeit"
        :value="displayWorkTime"
        icon="ri-briefcase-line"
        theme="indigo"
        size="small"
        :loading="isLoading"
    />

    <OverviewMetricCard
        title="Pausenzeit"
        :value="displayPauseTime"
        icon="ri-pause-circle-line"
        theme="orange"
        size="small"
        :loading="isLoading"
    />
</div>
